<template lang="html">
    <div class="app-input-container" :class="{open: open}" oncontextmenu="return false;">
      <transition name="fade" enter-active-class="fadeInUp" leave-active-class="fadeOutDown">
      <div class="wcc app-input" v-if="open">
        <div class="wcc app-input-controls-container">
          <div class="wcc app-input-controls">
            <button tabindex="0" class="wcc app-input-control cancel" v-hammer:tap="cancelInput">Cancel</button>
            <button tabindex="1" class="wcc app-input-control close" v-hammer:tap="commitInput">Done</button>
          </div>
        </div>
        <div class="wcc app-input-buttons-container">
          <div class="wcc app-input-buttons">
            <button tabindex="2" value="1" class="wcc app-input-button" :class="{disabled: disableNumbers}" v-hammer:tap="alphaInput">1</button>
            <button tabindex="3" value="2" class="wcc app-input-button" :class="{disabled: disableNumbers}" v-hammer:tap="alphaInput">2</button>
            <button tabindex="4" value="3" class="wcc app-input-button" :class="{disabled: disableNumbers}" v-hammer:tap="alphaInput">3</button>
            <button tabindex="5" value="4" class="wcc app-input-button" :class="{disabled: disableNumbers}" v-hammer:tap="alphaInput">4</button>
            <button tabindex="6" value="5" class="wcc app-input-button" :class="{disabled: disableNumbers}" v-hammer:tap="alphaInput">5</button>
            <button tabindex="7" value="6" class="wcc app-input-button" :class="{disabled: disableNumbers}" v-hammer:tap="alphaInput">6</button>
            <button tabindex="8" value="7" class="wcc app-input-button" :class="{disabled: disableNumbers}" v-hammer:tap="alphaInput">7</button>
            <button tabindex="9" value="8" class="wcc app-input-button" :class="{disabled: disableNumbers}" v-hammer:tap="alphaInput">8</button>
            <button tabindex="10" value="9" class="wcc app-input-button" :class="{disabled: disableNumbers}" v-hammer:tap="alphaInput">9</button>
            <button tabindex="11" class="wcc app-input-button" :class="{disabled: disableDecimal}" v-hammer:tap="decimalInput">.</button>
            <button tabindex="12" value="0" class="wcc app-input-button" :class="{disabled: disableNumbers}" v-hammer:tap="alphaInput">0</button>
            <button tabindex="13" class="wcc app-input-button" v-hammer:tap="back" v-hammer:press="clear"><font-awesome-icon :icon="['fas', 'backspace']" /></button>
          </div>
        </div>
      </div>
  </transition>
    </div>
</template>
<script>
  export default {
    methods: {
      cancelInput() {
        this.$store.dispatch('appInput/cancelInput')
      },
      commitInput() {
        this.$store.dispatch('appInput/commitInput')
      },
      removeFocus($event) {
        setTimeout(() => {
          $event.target ? $event.target.blur() : ''
        }, 300)
      },
      alphaInput($event) {
        if (!this.disableNumbers && this.boundData) {
          let value = $event.key ? $event.key : $event.target.getAttribute('value')

          // keypad
          if (value >= 96) {
            value -= 96
          }

          if (this.boundData.value == "0") {
            this.boundData.value = value
          } else {
            this.boundData.value += value
          }
          this.removeFocus($event)
        }
      },
      decimalInput($event) {
        if (!this.disableDecimal && this.boundData) {
          this.boundData.value += '.'
          this.removeFocus($event)
        }
      },
      back($event) {
        this.boundData.value = this.boundData.value.slice(0, -1)
        this.removeFocus($event)
      },
      clear($event) {
        this.boundData.value = ''
        this.removeFocus($event)
      }
    },
    computed: {
      disableDecimal() {
        if (this.boundData) {
          if (this.boundData.value.indexOf('.') == -1) {
            return false
          } else {
            return true
          }
        } else {
          return false
        }
      },
      disableNumbers() {
        if (this.boundData) {
          let decimalIndex = this.boundData.value.indexOf('.')
          let inputLength = this.boundData.value.length
          if (this.boundData.decimalLimit > -1) {
            if ( decimalIndex > -1) {
              if (inputLength > decimalIndex + this.boundData.decimalLimit) {
                return true
              } else {
                return false
              }
            } else {
              return false
            }
          } else {
            return false
          }
        } else {
          return false
        }
      },
      open() {
        return this.$store.state.appInput.open
      },
      boundData() {
        return this.$store.state.appInput.boundData
      }
    },
    mounted() {
      let vm = this
      // document.addEventListener('contextmenu', event => event.preventDefault())
      window.addEventListener("keydown", function(e) {
        // So it won't interfere with email inputs
        if (vm.boundData && e.key !== 'undefined') {
          let reAlpha = /[0-9]+/
          if (e.key.match(reAlpha)) {
            e.preventDefault()
            vm.alphaInput(e)
          } else if (e.key == '.') {
            e.preventDefault()
            vm.decimalInput(e)
          } else if (e.key == 'Backspace' || e.key == 'Delete') {
            e.preventDefault()
            vm.back(e)
          } else if (e.key == 'Enter') {
            e.preventDefault()
            vm.commitInput()
          } else if (e.key == 'Escape' || e.key == 'Esc') {
            e.preventDefault()
            vm.cancelInput()
          }
        }
      })
    }
  }
</script>
<style lang="scss">
  $wcc-app-input-primary: $blue-mr;
  $wcc-app-input-disabled: $grey-900;
  $wcc-app-input-item-height: 3.5em;

  .app-input-container {
    background-color: $grey-200;
    transition-duration: $animationDuration;
    height: 0em;
    &.open {
      height: 16.65em;
    }
  }

  .wcc.app-input {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: $wcc-app-input-primary;

    z-index: 99;
    
    .wcc.app-input-controls-container {
      background-color: darken($wcc-app-input-primary, 5%);
      display: flex;
      justify-content: center;
      .wcc.app-input-controls {
        display: flex;
        justify-content: space-between;
        width: 100%;
        max-width: $max-width;
        .wcc.app-input-control {
          color: white;
          width: calc(100% / 3);
          text-align: center;
          padding: $wcc-app-input-item-height/5 $wcc-app-input-item-height/4;
          user-select: none;
          font-size: .9em;
          cursor: pointer;
          transition-duration: $animationDuration;
          border: none;
          background-color: darken($wcc-app-input-primary, 5%);
          &:focus {
            background-color: lighten($wcc-app-input-primary, 10%);
            outline: 0;
          }
        }
      }
    }

    .wcc.app-input-buttons-container {
      display: flex;
      justify-content: center;

      .wcc.app-input-buttons {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        max-width: $max-width;
        .wcc.app-input-button {
          color: white;
          user-select: none;
          cursor: pointer;
          width: calc(100% / 3);
          font-size: 1em;
          padding: $spacing*.8;
          vertical-align: middle;
          text-align: center;
          transition-duration: $animationDuration;
          background-color: $wcc-app-input-primary;
          border: none;
          &:focus {
            background-color: lighten($wcc-app-input-primary, 10%);
            outline: 0;
          }
          &.disabled {
            background-color: $wcc-app-input-disabled;
            &:focus {
              outline: 0;
            }
          }
        }
      }

    }
  }
  
</style>